import Vue from 'vue';
const playerjsInit = async () => import('player.js');
import logger from '@lumiere/shared/services/logger';
import { sleep } from '@lumiere/shared/utils/sleep';
const EventListerOptions = {
    // causes the automatic removal of the event listener
    once: true,
    capture: true,
    passive: true,
};
const ATTEMP_RETRIES_COUNT = 5;
export default Vue.extend({
    name: 'EmbedPlayerJS',
    props: {
        autoplay: Boolean,
        vjs: Object,
    },
    methods: {
        setupIframeInteraction() {
            // https://gist.github.com/jaydson/1780598
            window.focus();
            // for the iframe
            document.addEventListener('click', this.respondToInteraction, EventListerOptions);
            document.addEventListener('touchstart', this.respondToInteraction, EventListerOptions);
            // for the iframe container
            window.addEventListener('blur', this.handleInteraction, EventListerOptions);
            window.addEventListener('touchstart', this.handleInteraction, EventListerOptions);
        },
        handleInteraction() {
            sleep(0).then(() => {
                this.simulateUserInteraction();
            });
        },
        respondToInteraction() {
            sleep(0).then(() => {
                this.simulateUserInteraction();
                if (this.autoplay && document.activeElement) {
                    this.attemptToPlayVideo();
                }
                this.vjs?.muted(false);
            });
        },
        attemptToPlayVideo() {
            this.vjs?.muted(true);
            let retriesCount = 0;
            const attemptToPlay = setInterval(() => {
                if (retriesCount < ATTEMP_RETRIES_COUNT) {
                    this.vjs
                        ?.play()
                        ?.then(() => {
                        clearInterval(attemptToPlay);
                    })
                        .catch((e) => logger.error('should autoplay embed', e));
                    retriesCount++;
                }
                else {
                    clearInterval(attemptToPlay);
                }
            }, 2000);
        },
        simulateUserInteraction() {
            document.body.focus();
            document.body.click();
            const observerRef = this.$refs.embedPlayerJS;
            if (observerRef) {
                const focus = new Event('focus');
                observerRef.dispatchEvent(focus);
                const hover = new Event('mouseover');
                observerRef.dispatchEvent(hover);
                const click = new Event('click');
                observerRef.dispatchEvent(click);
            }
        },
    },
    watch: {
        vjs: {
            async handler(vjs) {
                if (vjs) {
                    vjs.muted(true);
                    const playerjs = await playerjsInit();
                    const adapter = new playerjs.VideoJSAdapter(vjs);
                    // Start accepting events
                    adapter.ready();
                    this.$emit('playerjs-initialized');
                    adapter.receiver.methods?.['mute']?.();
                    // * Setup embed interaction config
                    this.setupIframeInteraction();
                    sleep(500).then(() => {
                        adapter.receiver.methods?.['unmute']?.();
                    });
                }
            },
            immediate: true,
        },
    },
});
